/**
 * @generated SignedSource<<ec8e78f47f1649fcd6c77503ccf5b56d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubmitDisplayElementInput = {
  clientMutationId?: string | null;
  contentSubmissionId: string;
  displayElementId: string;
};
export type SubmitDisplayElementButton_SubmitDisplayElementMutation$variables = {
  input: SubmitDisplayElementInput;
};
export type SubmitDisplayElementButton_SubmitDisplayElementMutation$data = {
  readonly LearnV2: {
    readonly submitDisplayElement: {
      readonly contentSubmission: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"contentSubmissionEnd_ContentSubmissionFragment">;
      };
    } | null;
  };
};
export type SubmitDisplayElementButton_SubmitDisplayElementMutation = {
  response: SubmitDisplayElementButton_SubmitDisplayElementMutation$data;
  variables: SubmitDisplayElementButton_SubmitDisplayElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containedElementTypes",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasonConfigTypes",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "ELearningContentSubmissionRelativeProgress",
  "kind": "LinkedField",
  "name": "relativeProgress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numCorrect",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numElements",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageCorrect",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "certificateName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "IssuedCertificateV2",
    "kind": "LinkedField",
    "name": "issuedCertificate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "fileRef",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubmitDisplayElementButton_SubmitDisplayElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Mutations",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SubmitDisplayElementPayload",
            "kind": "LinkedField",
            "name": "submitDisplayElement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "contentSubmissionEnd_ContentSubmissionFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubmitDisplayElementButton_SubmitDisplayElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Mutations",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SubmitDisplayElementPayload",
            "kind": "LinkedField",
            "name": "submitDisplayElement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentSubmission",
                "kind": "LinkedField",
                "name": "contentSubmission",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "learnOpportunity",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "nextContentNode",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/)
                                ],
                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": true,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "InfectopharmTreeConfigConsequences",
                                            "kind": "LinkedField",
                                            "name": "configConsequences",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "rewardExpired",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "showAnswerExpired",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WordpressCertificateAndLearnState",
                                            "kind": "LinkedField",
                                            "name": "wordpressCertificates",
                                            "plural": true,
                                            "selections": [
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "LearnOpportunityRootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "viewerTreeState",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v9/*: any*/),
                                        "type": "CanNotBeStartedViewerTreeState",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "headContentId",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "IsStartedViewerTreeState",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "attachmentsV2",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fileType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accessType",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                  }
                                ],
                                "type": "InfectopharmFileAttachment",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "definitionType",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "contentNodeAdvancementResult",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "configResults",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "configType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isRestartIfFailedContentConfigResult"
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "canBeRestarted",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "blockedUntil",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "NegativeBlockTemporarilyRestartIfFailedContentConfigResult",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v9/*: any*/),
                                    "type": "CanNotBeStartedContentNodeAdvancementResult",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "activeContentSubmissionId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ContinueContentNodeAdvancementResult",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pacPoints",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pharmaPoints",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "headFirstElementType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentConfigConsequences",
                                        "kind": "LinkedField",
                                        "name": "configConsequences",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBlockedPermanentlyAfterNumFailedTries",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnContentExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortDescription",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "type": "FailedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rewardResults",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rewardKind",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v13/*: any*/),
                                "type": "PharmaPointsRewardWasPossibleResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v13/*: any*/),
                                "type": "PacPointsRewardWasPossibleResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "FachberaterWasAwardedResult",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "CertificateRewardWasPossibleResult",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PassedELearningContentSubmissionDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canGoToPrevious",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveELearningContentSubmissionDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d01317f2f4a54a7c4761e2053874920",
    "id": null,
    "metadata": {},
    "name": "SubmitDisplayElementButton_SubmitDisplayElementMutation",
    "operationKind": "mutation",
    "text": "mutation SubmitDisplayElementButton_SubmitDisplayElementMutation(\n  $input: SubmitDisplayElementInput!\n) {\n  LearnV2 {\n    submitDisplayElement(input: $input) {\n      contentSubmission {\n        id\n        ...contentSubmissionEnd_ContentSubmissionFragment\n      }\n    }\n  }\n}\n\nfragment AttachmentCard_AttachmentFragment on InfectopharmFileAttachment {\n  id\n  file {\n    name\n    url\n    fileType\n    accessType\n    id\n  }\n  title\n  description\n}\n\nfragment AttachmentDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        ...AttachmentCard_AttachmentFragment\n      }\n      id\n    }\n  }\n}\n\nfragment ContentElementContainer_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      canGoToPrevious\n      progress {\n        __typename\n        percentage\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    ...AttachmentDisplay_LearnOpportunityV2Fragment\n  }\n}\n\nfragment FailedContentButton_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    status\n  }\n  learnOpportunity {\n    root {\n      id\n    }\n    id\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        extension {\n          __typename\n          ... on LearnContentExtensionImpl {\n            configConsequences {\n              isBlockedPermanentlyAfterNumFailedTries\n            }\n          }\n        }\n        contentNodeAdvancementResult {\n          __typename\n          status\n          ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n            configResults {\n              __typename\n              configType\n              __isRestartIfFailedContentConfigResult: __typename\n              canBeRestarted\n              ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                canBeRestarted\n              }\n              ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                blockedUntil\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            wordpressCertificates {\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      definitionType\n      contentNodeAdvancementResult {\n        __typename\n        status\n        ... on CanNotBeStartedContentNodeAdvancementResult {\n          reasonConfigTypes\n        }\n        ... on ContinueContentNodeAdvancementResult {\n          activeContentSubmissionId\n        }\n        ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n          status\n          configResults {\n            __typename\n            configType\n            __isRestartIfFailedContentConfigResult: __typename\n            canBeRestarted\n            ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n              canBeRestarted\n            }\n            ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n              blockedUntil\n            }\n          }\n        }\n      }\n      containedElementTypes\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            wordpressCertificates {\n              id\n            }\n          }\n        }\n        viewerTreeState {\n          __typename\n          kind\n          ... on CanNotBeStartedViewerTreeState {\n            reasonConfigTypes\n          }\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          pacPoints\n          pharmaPoints\n          headFirstElementType\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectContentElementContainer_ContentSubmissionFragment on ContentSubmission {\n  id\n  definition {\n    __typename\n    ... on ActiveELearningContentSubmissionDefinition {\n      canGoToPrevious\n      progress {\n        __typename\n        percentage\n      }\n    }\n  }\n  learnOpportunity {\n    id\n    root {\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n      }\n    }\n    ...AttachmentDisplay_LearnOpportunityV2Fragment\n  }\n}\n\nfragment contentSubmissionEnd_ContentSubmissionFragment on ContentSubmission {\n  id\n  learnOpportunity {\n    id\n    nextContentNode {\n      structureDefinition {\n        __typename\n        title\n      }\n      typeDefinition {\n        __typename\n        ... on LearnOpportunityELearningContentTypeDefinition {\n          containedElementTypes\n        }\n      }\n      id\n    }\n    root {\n      structureDefinition {\n        __typename\n        title\n        ... on LearnOpportunityRootStructureDefinition {\n          tags {\n            name\n            id\n          }\n          extension {\n            __typename\n            ... on LearnOpportunityRootExtensionImpl {\n              configConsequences {\n                rewardExpired\n                showAnswerExpired\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n        contentNodeAdvancementResult {\n          __typename\n          status\n          ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n            configResults {\n              __typename\n              configType\n              __isRestartIfFailedContentConfigResult: __typename\n              canBeRestarted\n              ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                canBeRestarted\n              }\n              ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                blockedUntil\n              }\n            }\n          }\n        }\n      }\n    }\n    ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n    ...NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment\n  }\n  definition {\n    __typename\n    status\n    ... on FailedELearningContentSubmissionDefinition {\n      relativeProgress {\n        numCorrect\n        numElements\n        percentageCorrect\n      }\n    }\n    ... on PassedELearningContentSubmissionDefinition {\n      relativeProgress {\n        numCorrect\n        numElements\n        percentageCorrect\n      }\n      rewardResults {\n        __typename\n        kind\n        rewardKind\n        ... on PharmaPointsRewardWasPossibleResult {\n          amount\n        }\n        ... on PacPointsRewardWasPossibleResult {\n          amount\n        }\n        ... on FachberaterWasAwardedResult {\n          certificateName\n          issuedCertificate {\n            fileRef {\n              url\n              id\n            }\n          }\n        }\n        ... on CertificateRewardWasPossibleResult {\n          certificateName\n          issuedCertificate {\n            fileRef {\n              url\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n  ...ContentElementContainer_ContentSubmissionFragment\n  ...FailedContentButton_ContentSubmissionFragment\n  ...ProjectContentElementContainer_ContentSubmissionFragment\n}\n"
  }
};
})();

(node as any).hash = "879f60545a21cd6c219e99a25a899fdc";

export default node;
